import './EmptyState.scss';

import AppButton from './buttons/AppButton';
import AppLinkButton from './buttons/AppLinkButton';
import PropTypes from 'prop-types';
import React from 'react';

const SIZES = {
  sm: { illus: 96, gap: 8, title: 16, desc: 14 },
  md: { illus: 128, gap: 10, title: 18, desc: 15 },
  lg: { illus: 160, gap: 12, title: 20, desc: 16 },
};

function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon,
  illustrationSrc,
  size = 'md',
  className,
  secondaryActionLabel,
  onSecondaryAction,
}) {
  const tokens = SIZES[size] || SIZES.md;

  return (
    <div className={['empty-state', `empty-state--${size}`, className || ''].join(' ')}>
      {illustrationSrc ? (
        <img
          src={illustrationSrc}
          alt=""
          aria-hidden="true"
          className="empty-state__illustration"
          style={{ width: tokens.illus, height: tokens.illus }}
        />
      ) : icon ? (
        <div className="empty-state__icon" aria-hidden="true" style={{ fontSize: tokens.illus / 3 }}>
          {icon}
        </div>
      ) : null}

      <h3 className="empty-state__title" style={{ fontSize: tokens.title }}>{title}</h3>

      {description && (
        <p className="empty-state__description" style={{ fontSize: tokens.desc }}>
          {description}
        </p>
      )}

      {(actionLabel || secondaryActionLabel) && (
        <div className="empty-state__actions" style={{ gap: tokens.gap }}>
          {actionLabel && (
            <AppButton name={actionLabel} onClick={onAction} size="md" fullWidth={false} />
          )}
          {secondaryActionLabel && (
            <AppLinkButton
              name={secondaryActionLabel}
              onClick={onSecondaryAction}
              size="md"
              variantStyle="ghost"
              fullWidth={false}
            />
          )}
        </div>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  icon: PropTypes.node,
  illustrationSrc: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  secondaryActionLabel: PropTypes.string,
  onSecondaryAction: PropTypes.func,
};

export default EmptyState;